module.exports = __webpack_public_path__ + "img/login.876c85bd.svg";